module.exports = __webpack_public_path__ + "img/layer-bg_04.55e22aed.jpg";